export default "__VITE_ASSET__BFTUW_0R__"